import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import {
  fetchCandidateTransactionsFailed,
  fetchCandidateTransactionsSuccess,
} from 'redux/applicants/actions';
import ApplicantsActionTypes from '../types';

const { API_BASE_URL } = urls || {};

function* fetchTransactions({ payload }) {
  const { candidateId } = payload;
  const url = `${API_BASE_URL}/candidates/${candidateId}/transactions `;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchCandidateTransactionsSuccess(response?.raw || []));
  } else {
    yield put(fetchCandidateTransactionsFailed(response.message));
  }
}

export function* getApplicantTransactions() {
  yield takeEvery(
    ApplicantsActionTypes.FETCH_APPLICANT_TRANSACTIONS_START,
    fetchTransactions
  );
}
